export const LogbookEnterpriseRoutes = [
    {
        "url": "/enterprise-logbook",
        "name": "appLayout.harriSH.enterprise-logbook",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "component": "logbookMain",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/logbook/logbook.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/manage-entries?date",
        "name": "appLayout.harriSH.enterprise-logbook.entries",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookManageEntries",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ],
    },
    {
        "url": "/tasks?my-tasks&date&view",
        "name": "appLayout.harriSH.enterprise-logbook.tasks",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookTeamTasks",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ],
    },
    {
        "url": "/checklists?view",
        "name": "appLayout.harriSH.enterprise-logbook.checklists",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookViewChecklists",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ],
    },
    {
        "url": "/manage-task-details?type&id&duplicate&isTodo",
        "name": "appLayout.harriSH.enterprise-logbook.task-details",
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "logbook-body": {
                "component": "logbookTaskChecklistDetailsContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["logbook"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Logbook"
            }
        ],
    }
];
//# sourceMappingURL=logbook-enterprise.routes.js.map